<template>
  <el-button-group>
    <el-button v-if="this.$fun.isQx(this.qx, 'role:add')" type="primary" icon="Plus" @click="addInfo">添加</el-button>
    <el-button v-if="this.$fun.isQx(this.qx, 'role:edit')" type="warning" icon="Edit" @click="editInfo">修改</el-button>
    <el-button v-if="this.$fun.isQx(this.qx, 'role:del')" type="danger" icon="Delete" @click="delInfo">删除</el-button>
    <el-button v-if="this.$fun.isQx(this.qx, 'role:enable')" type="success" icon="CircleCheck" @click="enableInfo(true)">启用</el-button>
    <el-button v-if="this.$fun.isQx(this.qx, 'role:enable')" type="info" icon="CircleClose" @click="enableInfo(false)">禁用</el-button>
    <el-button v-if="this.$fun.isQx(this.qx, 'role:module')" type="warning" icon="Key" @click="setModule">设置功能</el-button>
  </el-button-group>
  <el-row :gutter="2">
    <el-col :span="14">
      <el-table v-loading="tableLoading" :data="tableData" highlight-current-row stripe border
          :height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" @current-change="handleCurrentRowChange"
          header-row-class-name="header-row" header-cell-class-name="header-cell">
        <el-table-column type="selection" width="40"></el-table-column>
        <!-- <el-table-column type="index" label="序" width="40"></el-table-column> -->
        <el-table-column prop="name" label="角色名称" sortable  width="150"></el-table-column>
        <el-table-column prop="desc" label="角色描述"></el-table-column>
        <el-table-column prop="queue" label="排序" sortable width="80"></el-table-column>
        <el-table-column label="状态" width="60">
          <template #default="scope">
            <el-icon v-if="scope.row.isEnable" class="check" title="启用"><Check /></el-icon>
            <el-icon v-else class="close" title="禁用"><Close /></el-icon>
          </template>
        </el-table-column>
      </el-table>
    </el-col>
    <el-col :span="10">
      <el-table v-loading="userTableLoading" :data="userTableData" highlight-current-row stripe border
          height="100%" style="width: 100%"
          header-row-class-name="header-row" header-cell-class-name="header-cell">
        <el-table-column prop="adminName" label="用户名" sortable width="130"></el-table-column>
        <el-table-column label="姓名" width="130">
          <template #default="scope">
            {{scope.row.name}} ({{scope.row.gender}})
          </template>
        </el-table-column>
        <el-table-column prop="department" label="部门"></el-table-column>
      </el-table>
    </el-col>
  </el-row>
  <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
   :current-page="currentPage" :page-sizes="[10, 15, 20, 30, 40]"
   :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total='tableTotal'>
  </el-pagination>
  <el-dialog :title="dialogTitle" v-model="dialogFormVisible" :close-on-click-modal="false" :before-close="closeForm">
    <el-form ref="formRef" :model="form" :rules="rules" label-width="130px">
      <el-input v-model="form.id" type="hidden"></el-input>
      <el-form-item label="角色名称" prop="name">
          <el-input v-model="form.name" class="width"></el-input>
      </el-form-item>
      <el-form-item label="角色描述" prop="desc">
        <el-input v-model="form.desc" type="textarea" maxlength="200" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="排序">
        <el-input-number v-model="form.queue" :min="0" />
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="closeForm">关 闭</el-button>
        <el-button @click="resetForm">重 填</el-button>
        <el-button type="primary" @click="saveInfo">确 定</el-button>
      </span>
    </template>
  </el-dialog>
  <!-- 设置功能模块对话框 -->
  <el-dialog title="设置功能模块" v-model="dialogModuleVisible" :close-on-click-modal="false" :before-close="closeFormModule">
    <el-tree ref="moduleTree" v-loading="moduleLoading" :data="moduleData" show-checkbox node-key="value" default-expand-all
      :default-checked-keys="[5]" :props="defaultProps">
    </el-tree>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="closeFormModule">关 闭</el-button>
        <el-button type="primary" @click="saveSet">确 定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'role',
  data () {
    return {
      qx: '',
      tableLoading: false,
      currentPage: 1,
      pagesize: 15,
      tableTotal: 0,
      tableData: [],
      selectionIds: '',
      dialogFormVisible: false,
      dialogTitle: '',
      form: {
        id: '',
        name: '',
        desc: '',
        queue: 0
      },
      rules: {
        name: [
          { required: true, message: '请输入角色名称', trigger: 'blur' },
          { min: 3, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur' }
        ]
      },
      rid: '',
      defaultProps: {
        children: 'children'
        // label: 'name'
      },
      moduleData: [],
      moduleLoading: false,
      dialogModuleVisible: false,
      // roleid: '',
      userTableLoading: false,
      userTableData: []
    }
  },
  // 接收父组件传值
  props: ['clientHeight'],
  mounted () {
    this.qx = this.$route.params.qx
    this.getTableHeight()
    this.getData()
  },
  methods: {
    // pageSize 新每页条数改变时触发(每页下拉显示数据)
    handleSizeChange (size) {
      this.pagesize = size
      this.getData()
    },
    // 新当前页改变时触发(点击第几页)
    handleCurrentChange (currentPage) {
      this.currentPage = currentPage
      this.getData()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
      this.selectionIds = ''
      for (var i = 0; i < val.length; i++) {
        this.selectionIds += val[i].id + ','
      }
      // if (this.multipleSelection.length === 1) {
      //   // 选择的当前角色id
      //   var roleid = this.multipleSelection[0].id
      //   this.getAdminData(roleid)
      // }
    },
    handleCurrentRowChange (val) {
      if (val !== undefined && val !== null) {
        var roleid = val.id
        this.getAdminData(roleid)
      }
    },
    async getData () {
      this.tableLoading = true
      const params = '?pagesize=' + this.pagesize + '&pageindex=' + this.currentPage
      const { data: ret } = await this.$http.get(this.$api.rolelist + params)
      if (ret.status === 0) {
        this.tableData = ret.data.rows
        this.tableTotal = ret.data.total
      }
      this.tableLoading = false
    },
    async getAdminData (rid) {
      this.userTableLoading = true
      const params = '?rid=' + rid
      const { data: ret } = await this.$http.get(this.$api.roleadminlist + params)
      if (ret.status === 0) {
        this.userTableData = ret.data
      }
      this.userTableLoading = false
    },
    addInfo () {
      this.form.id = ''
      this.dialogTitle = '添加角色'
      this.dialogFormVisible = true
    },
    async editInfo () {
      if (this.multipleSelection === undefined || this.multipleSelection.length !== 1) {
        this.$message.error('请选择一条信息修改。')
        return
      }
      this.dialogFormVisible = true
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const { data: ret } = await this.$http.get(this.$api.roleid + '/' + this.multipleSelection[0].id)
      if (ret.status === 0 && ret.data !== null) {
        const obj = ret.data
        Object.keys(this.form).forEach(key => {
          this.form[key] = obj[key]
        })
        this.dialogTitle = '修改角色'
      } else {
        this.$message.error(ret.message)
      }
      loading.close()
    },
    saveInfo () {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          const { data: ret } = await this.$http.post(this.$api.rolesave, this.form)
          if (ret.status === 0) {
            this.$message.success(ret.message)
            this.getData()
            this.closeForm()
          } else {
            this.$message.error(ret.message)
          }
          loading.close()
        } else {
          this.$message.error('验证没通过。')
          return false
        }
      })
    },
    delInfo () {
      if (this.selectionIds === '') {
        this.$message.error('请选择将删除的信息。')
        return
      }
      this.$confirm('此操作将删除已选择的信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        const { data: ret } = await this.$http.post(this.$api.roledel + '?ids=' + this.selectionIds)
        if (ret.status === 0) {
          this.getData()
          this.$message.success(ret.message)
        } else {
          this.$message.error(ret.message)
        }
        loading.close()
      })
    },
    async enableInfo (bo) {
      const s = bo ? '启用' : '禁用'
      if (this.selectionIds === '') {
        this.$message.error('请选择将' + s + '的信息。')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const params = '?ids=' + this.selectionIds + '&bo=' + bo
      console.log(params)
      const { data: ret } = await this.$http.post(this.$api.roleenable + params)
      if (ret.status === 0) {
        this.getData()
        this.$message.success(ret.message)
      } else {
        this.$message.error(ret.message)
      }
      loading.close()
    },
    resetForm () {
      this.$refs.formRef.resetFields()
    },
    closeForm () {
      this.$refs.formRef.resetFields()
      this.dialogFormVisible = false
    },
    // 角色模块表数据
    async getModuleData () {
      this.moduleLoading = true
      const { data: ret } = await this.$http.get(this.$api.rolegetmodulelist + '?rid=' + this.rid)
      if (ret.status === 0 && ret.data !== null) {
        // console.log('moduleData=', ret.data.data)
        this.moduleData = ret.data.data
        this.$refs.moduleTree.setCheckedKeys([])
        this.$refs.moduleTree.setCheckedKeys(ret.data.idlist)
      }
      this.moduleLoading = false
    },
    setModule () {
      if (this.multipleSelection === undefined || this.multipleSelection.length !== 1) {
        this.$message.error('请选择一条信息设置。')
        return
      }
      this.rid = this.multipleSelection[0].id
      this.getModuleData()
      this.dialogModuleVisible = true
    },
    async saveSet () {
      // var ids = this.$refs.moduleTree.getCheckedKeys()
      // var nodes = this.$refs.moduleTree.getCheckedNodes()
      // // console.log('CheckedNodes=', nodes)
      // // 模块id
      // var mid = ''
      // // 按钮id
      // var bid = ''
      // // 格式：模块id|权限标识/权限标识/权限标识,模块id|权限标识/权限标识/权限标识
      // var ids = ''
      // nodes.forEach(node => {
      //   if (node.type === 1) {
      //     if (mid !== node.id) {
      //       mid = node.id
      //       ids += ids === '' ? node.id : ',' + node.id
      //       bid = ''
      //     }
      //   } else if (node.type === 2) {
      //     if (mid === node.parentId) {
      //       bid = bid === '' ? '|' + node.link : '/' + node.link
      //       ids += bid
      //     } else {
      //       bid = ''
      //       mid = node.parentId
      //       ids += ids === '' ? node.parentId : ',' + node.parentId
      //       bid = bid === '' ? '|' + node.link : '/' + node.link
      //       ids += bid
      //     }
      //   }
      // })
      var nodes = this.$refs.moduleTree.getCheckedNodes()
      var pnodes = this.$refs.moduleTree.getHalfCheckedKeys()
      // console.log('CheckedNodes=', nodes)
      var ids = ''
      nodes.forEach(node => {
        var id = node.value + '|' + node.type
        ids += ids === '' ? id : ',' + id
      })
      // console.log('ids=', ids)
      var pids = ''
      pnodes.forEach(node => {
        var id = node
        pids += pids === '' ? id : ',' + id
      })
      var obj = {
        roleId: this.rid,
        moduleIds: ids,
        pIds: pids
      }
      // console.log('obj=', obj)
      const { data: ret } = await this.$http.post(this.$api.rolesaveset, obj)
      if (ret.status === 0) {
        this.closeFormModule()
        this.$message.success(ret.message)
      } else {
        this.$message.error(ret.message)
      }
    },
    closeFormModule () {
      this.rid = ''
      this.$refs.moduleTree.setCheckedKeys([])
      this.dialogModuleVisible = false
    },
    getTableHeight () {
      this.tableHeight = this.clientHeight - 84 - 39
    }
  },
  watch: {
    clientHeight: function (val) {
      this.getTableHeight()
    }
  }
}
</script>

<style>
</style>
